import { useState } from "react";
import { useTranslation } from "react-i18next";
import { LegalDocumentsDialog } from "../bridges/publicAssets";
import { ContactLink } from "./PublicContact";
import { LanguageMenu } from "./LanguageMenu";
import { hasPublicPreviewCookie } from "./mode";
import s from "./public.module.scss";

/** The one footer of every public page (P1.4): Terms & Privacy (today's dialog), Contact us (the pop-up) and the language menu. ב״ה is only at the top. */
export const PublicFooter = ({ withLanguage = true, className, contact = true }: { withLanguage?: boolean; className?: string; contact?: boolean }) => {
  const { t } = useTranslation();
  const [terms, setTerms] = useState(false);
  return (
    <footer className={`${s.footer} ${className ?? ""}`}>
      <button type="button" className={s.footLink} onClick={() => setTerms(true)} aria-haspopup="dialog">{t("legal_docs.button")}</button>
      {contact && <ContactLink>{t("landing_nav.contact_us")}</ContactLink>}
      {withLanguage && <LanguageMenu />}
      {hasPublicPreviewCookie() && <a id="cy-preview-off" className={s.footLink} href="/?preview=off">{t("landing_nav.preview_off")}</a>}
      <LegalDocumentsDialog open={terms} onClose={() => setTerms(false)} />
    </footer>
  );
};
